import mockArtistsData from "../../data/mockData/artistsData";
import { types } from "./action";

/**
 * Demo catalog mirrors releases: static seed, last GET page, and session-backed rows.
 * - seed: static mock rows
 * - tableRowResults: last paginated GET /artists/ page
 * - created: extras merged in browser-session demo (sessionStorage; cleared on demo logout)
 */
const initialState = {
  seed: mockArtistsData,
  tableRowResults: [],
  created: [],
};

function upsertById(rows, row) {
  if (!row || row.id == null) {
    return rows;
  }
  const sid = String(row.id);
  const idx = rows.findIndex(r => String(r.id) === sid);
  if (idx >= 0) {
    const next = [...rows];
    next[idx] = { ...next[idx], ...row };
    return next;
  }
  return [...rows, row];
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SET_ARTISTS:
      return {
        ...state,
        tableRowResults: Array.isArray(action.payload) ? action.payload : state.tableRowResults,
      };
    case types.HYDRATE_ARTISTS_FROM_SESSION:
      return {
        ...state,
        created: Array.isArray(action.payload) ? action.payload : [],
      };
    case types.ADD_ARTIST: {
      const row = action.payload;
      if (!row || row.id == null) {
        return state;
      }
      const exists = state.created.some(r => String(r.id) === String(row.id));
      if (exists) {
        return state;
      }
      return {
        ...state,
        created: [...state.created, row],
      };
    }
    case types.UPDATE_ARTIST: {
      const row = action.payload;
      if (!row || row.id == null) {
        return state;
      }
      return {
        ...state,
        created: upsertById(state.created, row),
      };
    }
    case types.DELETE_ARTIST: {
      const id = action.payload;
      if (id == null) {
        return state;
      }
      const sid = String(id);
      return {
        ...state,
        created: state.created.filter(r => String(r.id) !== sid),
      };
    }
    default:
      return state;
  }
};
